/*
 * Module that handles displaying the embedded Tableau report
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/adHoc/adHocReportView",
], function (Marionette, $, Messenger, AdHocReportView) {
  var AdHocReportController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "adHocReportModule";
      this.region = options.region;
    },
    show: function (url) {
      this.layout = new AdHocReportView.adHocReportLayout();
      this.showRegion(this.layout);
      this.layout.loadAdHocReport(url);
    },
  });

  return AdHocReportController;
});
